import { AdPlatform, CampaignOptimizationValue } from '@app/core/models/common.models';

type selectedParams = string[];

export interface SelectorDisplayLabel {
  payload: ListItem | selectedParams;
  type: 'SELECTED_ITEM' | 'FILTER' | 'LABEL';
}

export interface GlobalSelector {
  render: boolean;
  enable: boolean;
  enableAdvancedMode: boolean;
  enableAdvancedFilterSelection: boolean;
  disable: boolean;
  disableReset: boolean;
  notSelectable?: boolean;
  onSelectionChange: (data) => void;
  onReset: (data) => void;
}
export enum FilterMode {
  Source = 'SOURCE',
  Destination = 'DESTINATION',
}

export interface ListItem {
  id: string;
  name: string;
  type?: CampaignOptimizationValue;
  platform?: AdPlatform;
  accountName?: string;
  performanceGroupName?: string;
  logo?: string;
}

export type SelectorDisplayData = {
  src: any;
  dest: any;
  defaultSubfilters: any;
  multpleSelections: boolean;
  labels: {
    tooltip: string;
    buttonTexts: any;
  };
  selectedItems: {
    SOURCE: any;
    DESTINATION: any;
  };
};
export type SelectorTranslationTexts = {
  title: string;
  search: string;
  all: string;
  selected: string;
  applyTooltip: string;
  active?: string;
};
